
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import styles from './index.p.css';

const sizeStyles = {
  "xs": styles.sizeXS,"s": styles.sizeS,"m": styles.sizeM,"l": styles.sizeL
}
export const Size = {
  "xs": "xs","s": "s","m": "m","l": "l"
};

const DownIcon16 = React.forwardRef((props, ref) => (<svg viewBox="0 0 16 16" {...props} ref={ref}><path d="M11.53 5.97a.75.75 0 0 0-1.06 0L8 8.44 5.53 5.97a.75.75 0 0 0-1.06 1.06l3 3a.75.75 0 0 0 1.06 0l3-3a.75.75 0 0 0 0-1.06" /></svg>));
DownIcon16.displayName = 'DownIcon16';
const DownIcon20 = React.forwardRef((props, ref) => (<svg viewBox="0 0 20 20" {...props} ref={ref}><path d="M14.707 7.293a1 1 0 0 0-1.414 0L10 10.586 6.707 7.293a1 1 0 0 0-1.414 1.414l4 4a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0 0-1.414" /></svg>));
DownIcon20.displayName = 'DownIcon20';
const DownIcon24 = React.forwardRef((props, ref) => (<svg viewBox="0 0 24 24" {...props} ref={ref}><path d="M19.06 7.94a1.5 1.5 0 0 0-2.12 0L12 12.878l-4.94-4.94a1.5 1.5 0 1 0-2.12 2.122l6 6a1.5 1.5 0 0 0 2.12 0l6-6a1.5 1.5 0 0 0 0-2.122" /></svg>));
DownIcon24.displayName = 'DownIcon24';
const DownIcon28 = React.forwardRef((props, ref) => (<svg viewBox="0 0 28 28" {...props} ref={ref}><path d="M22.06 9.44a1.5 1.5 0 0 0-2.12 0L14 15.378l-5.94-5.94a1.5 1.5 0 1 0-2.12 2.122l7 7a1.5 1.5 0 0 0 2.12 0l7-7a1.5 1.5 0 0 0 0-2.122" /></svg>));
DownIcon28.displayName = 'DownIcon28';

const DownIcon = React.forwardRef(
  ({
    theme,
    size: sizeFromProps = "m",
    className,
    style,
    ['data-render-all-sizes']: renderAllSizes = false,
    ...props
  }, ref) => {
    const size = sizeFromProps in Size ? sizeFromProps : "m";
    const mainProps = {
      ...props,
      className: cn(styles.icon, styles[theme], sizeStyles[size], renderAllSizes && styles.allVariants, className),
      style: renderAllSizes ? { '--rs-icon-ar-width': 28, '--rs-icon-ar-height': 28, ...style } : style,
      ref
    };

    if (renderAllSizes) {
          return (<svg viewBox="0 0 28 28" {...mainProps}><DownIcon16 className={styles.variant16} />
<DownIcon20 className={styles.variant20} />
<DownIcon24 className={styles.variant24} />
<DownIcon28 className={styles.variant28} /></svg>);
          }
          if (size === Size['xs']) { return (<DownIcon16 {...mainProps} />); }
if (size === Size['s']) { return (<DownIcon20 {...mainProps} />); }
if (size === Size['m']) { return (<DownIcon24 {...mainProps} />); }
return (<DownIcon28 {...mainProps} />);
  }
);
DownIcon.displayName = 'DownIcon';
DownIcon.propTypes = {
  className: PropTypes.string,
  theme: PropTypes.oneOf(["light", "dark"]),
  size: PropTypes.oneOf(["xs", "s", "m", "l"]),
  'data-render-all-sizes': PropTypes.bool,
  style: PropTypes.object
};

export default DownIcon;